module.exports = __webpack_public_path__ + "static/media/s1.12b493dc.png";